import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import AdvertisingDetails from './AdvertisingDetails';
import { Template, Client } from '@horasys/bellplus/common/types';
import { Advertisement } from '@horasys/bellplus/common/types';
import { DeviceType } from '@horasys/bellplus/common/types';
import AdvertisementErrorBoundry from './AdvertisementErrorBoundry';
import { validateSchema } from 'validations/common';
import { advertisementSchema } from 'validations/advertisement.validation';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { DeviceTypeState, deviceTypesList } from 'Stores/Slices/deviceTypeSlice';
import { AdvertisementState, GENERATE_ADVERTISEMENT_ASSET, UPDATE_ADVERTISEMENT_FORM, createAdvertisementDetails, updateAdvertisementDetails } from 'Stores/Slices/advertisementSlice';
import { TemplateState, getAllTemplateDetailsByDeviceType } from 'Stores/Slices/templateSlice';
import { RootState } from 'Stores/store';

const CreateAdvertisementDetails = () => {
	const advertisementStore: AdvertisementState = useAppSelector(
		(state: RootState) => state.advertisement,
	);

	const userDtails = localStorage.getItem('userDetails');
	const parsedUserDetails = userDtails
		? JSON.parse(userDtails)
		: { data: { clientId: 1, id: 1, username: 'root' } };

	const client: Client = {} as Client;
	client.id = parsedUserDetails?.data.clientId;
	client.name = parsedUserDetails?.data?.username;
	const dispatch = useAppDispatch();
	const { advertisement, mode } = advertisementStore;
	const deviceTypeStore: DeviceTypeState = useAppSelector(
		(state: RootState) => state.deviceType,
	);
	const { list: deviceTypeList } = deviceTypeStore;

	const templateStore: TemplateState = useAppSelector((state: RootState) => state.template);
	const { tempDeviceTypeTemplateList: templatesList } = templateStore;
	const [advertisementErrorPopup, setAdvertisementErrorPopup] = useState(false);
	useEffect(() => {
		dispatch(deviceTypesList());
	}, [dispatch]);
	const [hasError, setHasError] = useState({
		advertisementName: '',
		templateId: '',
		clientId: '',
		assets: '',
	});

	const createAdvertisement = async () => {
		try {
			await validateSchema(advertisementSchema, advertisement);
			//await validateAdvertisement(advertisement);
			// check validity
			const errorObj: any = {};

			setHasError(errorObj);

			if (mode === 'CREATE') {
				dispatch(createAdvertisementDetails(advertisement));
			} else if (mode === 'EDIT') {
				dispatch(updateAdvertisementDetails(advertisement));
			}
		} catch (errorObj:any) {
			console.warn(errorObj);
			setHasError(errorObj);
			setAdvertisementErrorPopup(true);
		}
	};

	const AdvertisementErrorDialog = (props: any) => {
		const { shouldOpen, message, handleAdvertisementErrorPopup } = props;
		const [open, setOpen] = React.useState(false);
		const [, setErrorMsg] = React.useState<any>([]);
		useEffect(() => {
			setOpen(shouldOpen);
			const messages: any = [];
			Object.keys(message).forEach((key) => {
				if (key === 'assets') {
					messages.push('Upload all the required assets.');
				} else {
					messages.push(message[key]);
				}
			});
			setErrorMsg(messages);
		}, [shouldOpen, message]);

		const handleClose = () => {
			setOpen(false);
			handleAdvertisementErrorPopup();
		};

		return (
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">
					Please fill form accordingly.
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<ul>{/* {errorMsg.map((msg: any) => (
								<li>{msg}</li>
							))} */}</ul>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary" autoFocus>
						ok
					</Button>
				</DialogActions>
			</Dialog>
		);
	};

	// const validateAdvertismentName = async (value: any) => {
	// 	const obj = { clientId: 0, name: '' };
	// 	const id: any = advertisement.client.id;
	// 	obj.clientId = id;
	// 	obj.name = value;
	// 	const errorObj: any = {};
	// 	try {
	// 		await checkAdvertisementName(obj);
	// 		errorObj.advertisementName = '';
	// 		setHasError(errorObj);
	// 	} catch (error) {
	// 		errorObj.advertisementName = error;
	// 		setHasError(errorObj);
	// 	}
	// };
	const handleInputDetails = (e: any) => {
		const name: any = e.target.name;
		const value: any = e.target.value;

		switch (name) {
			case 'advertisementName':
				updateAdvertisement({ client: client, name: value });
				//validateAdvertismentName(value);
				break;

			case 'templateId':
				{
					const selectedTemplate: Array<Template> = templatesList.filter(
						(templ: Template) => {
							return templ.id === value;
						},
					);
					updateAdvertisement({
						template: selectedTemplate[0],
					});
					dispatch(GENERATE_ADVERTISEMENT_ASSET(selectedTemplate[0]));
				}
				break;

			case 'deviceType':
				{
					const selectedDeviceType: DeviceType = deviceTypeList.find(
						(devicetype: DeviceType) => {
							return devicetype.id === value;
						},
					);
					if (selectedDeviceType) {
						updateAdvertisement({ deviceType: selectedDeviceType });

						dispatch(
							getAllTemplateDetailsByDeviceType(selectedDeviceType.id),
						);
					}
				}
				break;

			default:
		}
	};

	const updateAdvertisement = (partialAdvertisement: Partial<Advertisement>) => {
		dispatch(UPDATE_ADVERTISEMENT_FORM(partialAdvertisement));
	};
	const handleAdvertisementErrorPopup = () => {
		setAdvertisementErrorPopup(false);
	};
	return (
		<div>
			<AdvertisementErrorBoundry>
				<AdvertisementErrorDialog
					shouldOpen={advertisementErrorPopup}
					message={hasError}
					handleAdvertisementErrorPopup={handleAdvertisementErrorPopup}
				/>
				<AdvertisingDetails
					templatesList={templatesList}
					handleInputDetails={handleInputDetails}
					createAdvertisement={createAdvertisement}
					isOpenViewModal={false}
					errorObj={hasError}
					viewMode={mode === 'VIEW'}
					advertisement={advertisement}
					mode={mode}
				/>
			</AdvertisementErrorBoundry>
		</div>
	);
};
export default CreateAdvertisementDetails;
